export default __webpack_public_path__ + "static/media/facebook-review.37dd7513.svg";